import React from 'react';
import { Select } from 'antd';
import { PAGE_SIZE_VALUES, DEFAULT_PAGE_SIZE } from '../../../constants/shared';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { automationIds } from '../../../constants/automationIds';
const StyledSelect = styled(Select) `
  width: 80px;
  margin-right: 8px;
`;
const PageSizeSelect = ({ onPageSizeChange, totalRecords, selectedValue, isDisabled }) => {
    const { t: translate } = useTranslation();
    const filteredPageSizes = PAGE_SIZE_VALUES.filter((size) => size < totalRecords);
    if (totalRecords <= DEFAULT_PAGE_SIZE)
        return null;
    return (<>
      <StyledSelect defaultValue={DEFAULT_PAGE_SIZE} size='small' onChange={onPageSizeChange} disabled={isDisabled} value={selectedValue} data-automation-id={automationIds.DATA_ENTRY.SHARED.SELECT.PAGE_SIZE}>
        {filteredPageSizes.map(value => (<Select.Option key={value} value={value} data-automation-id={automationIds.DATA_ENTRY.SHARED.SELECT.PAGE(value)}>
              {value}
            </Select.Option>))}
        <Select.Option key='all' value={totalRecords} data-automation-id={automationIds.DATA_ENTRY.SHARED.SELECT.PAGE('ALL')}>
        {translate('PAGINATION.ALL_ELEMENTS')}
        </Select.Option>
      </StyledSelect>
      {translate('PAGINATION.ELEMENTS_PER_PAGE')}
    </>);
};
export default PageSizeSelect;
